import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=b6f08fa2&scoped=true&"
import script from "./Oauth.vue?vue&type=script&lang=js&"
export * from "./Oauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f08fa2",
  null
  
)

export default component.exports